import React from "react";

export type ICustomDesignIconProps = {};

const CustomDesignIcon: React.FC<ICustomDesignIconProps> = ({}) => {
 return (
  <svg
   xmlns="http://www.w3.org/2000/svg"
   width={43}
   height={43.001}
   viewBox="0 0 43 43.001"
  >
   <path
    data-name="Path 3304"
    d="M41.394 29.779L34.7 26.875l6.692-2.9a2.017 2.017 0 001.049-2.65 2.021 2.021 0 00-2.653-1.047l-18.244 7.947L6.039 21.5l14.319-6.213a2.017 2.017 0 001.047-2.651 2.02 2.02 0 00-2.653-1.047L1.609 19.025A2.686 2.686 0 000 21.5a2.685 2.685 0 001.606 2.471L8.3 26.875l-6.691 2.9A2.688 2.688 0 000 32.252a2.685 2.685 0 001.606 2.473l18.332 7.95a4.649 4.649 0 001.561.326 3.958 3.958 0 001.561-.324l18.33-7.952A2.687 2.687 0 0043 32.252a2.683 2.683 0 00-1.606-2.473zm-19.85 9.2L6.039 32.25l7.325-3.178 6.575 2.853a3.9 3.9 0 001.561.324 3.926 3.926 0 001.561-.324l6.576-2.854 7.331 3.181zM41.656 7.391h-6.047V1.344A1.343 1.343 0 0034.265 0h-1.343a1.343 1.343 0 00-1.344 1.344v6.047h-6.047a1.343 1.343 0 00-1.344 1.344v1.344a1.343 1.343 0 001.344 1.346h6.047v6.047a1.343 1.343 0 001.344 1.344h1.344a1.343 1.343 0 001.344-1.344v-6.047h6.047A1.343 1.343 0 0043 10.078V8.734a1.343 1.343 0 00-1.344-1.343z"
    fill="#7c7c7c"
   />
  </svg>
 );
};

export { CustomDesignIcon };
